'use es6';

import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import PropTypes from 'prop-types';
import { Fragment, useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EmailPageContainer({
  children,
  titleKey = 'email-management.htmlTitle'
}) {
  useEffect(() => {
    setDocumentTitle(titleKey);
  }, [titleKey]);
  return /*#__PURE__*/_jsx(Fragment, {
    children: children
  });
}
EmailPageContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  titleKey: PropTypes.string
};